


export type LabelType = 'Competence' | 'Document';

export const LabelType = {
    Competence: 'Competence' as LabelType,
    Document: 'Document' as LabelType
};

